import { okGlobal } from '@ok/blade';

export default function getCoinIconUrl(symbol, size) {
  const postfix = size ? `_${size}` : '';
  const cdnPath = okGlobal.cdnBaseUrl;
  return symbol
    ? `${cdnPath}/cdn/assets/imgs/icon/${symbol.toLowerCase()}${postfix}.png`
    : '';
}

export const getImages = (path, size) => {
  const postfix = size ? `_${size}` : '';
  const cdnPath = okGlobal.cdnBaseUrl;
  return path ? `${cdnPath}/cdn/assets/imgs/${path}${postfix}.png` : '';
};
